import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css";
import "../css/index.css";
import "../css/font-awesome.min.css";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // 📌 Handle Subscription
  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setMessage("Please enter a valid email.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("https://api.irfanelectricals.com/api/subscriber", { email });
      setMessage("Subscription successful! ✅");
      setEmail(""); // Clear input
    } catch (error) {
      console.error("Subscription error:", error.response?.data || error.message);
      setMessage(error.response?.data?.message || "Subscription failed. ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section id="footer_top" className="p_3">
        <div className="container-xl">
          <div className="row footer_top_1 text-center">
            <div className="col-md-12">
              <h4 className="col_blue">Subscribe Newsletter</h4>
              <h1 className="mt-3">Get Updated News</h1>
              <p className="mt-3">
                Quality electrical solutions for homes and businesses. Reliable, affordable, and trusted services for all your needs.
              </p>
              <form onSubmit={handleSubscribe} className="mt-4">
                <div className="input-group w-75 mx-auto">
                  <input
                    type="email"
                    className="form-control border-0 bg_light"
                    placeholder="Your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button className="btn btn-primary bg_blue border-0" type="submit" disabled={loading}>
                    {loading ? "Subscribing..." : <i className="fa fa-envelope fs-4"></i>}
                  </button>
                </div>
              </form>
              {message && <p className="mt-2 text-light">{message}</p>}
            </div>
          </div>
        </div>
      </section>

      <section id="footer">
        <div className="footer_mb pt-3 pb-3">
          <div className="container-xl">
            <div className="row footer_1">
              <div className="col-md-4">
                <div className="footer_1i">
                  <h1 className="mt-3">
                    <a className="text-white" href="index.html">Irfan Electricals</a>
                  </h1>
                  <p className="mt-3 text-light">
                    Quality electrical solutions for homes and businesses. Reliable, affordable, and trusted services for all your needs.
                  </p>
                  <ul className="social-network social-circle mb-0 mt-3">
                    <li><a href="https://wa.me/+919898100371" className="icoWhatsapp" title="WhatsApp"><i className="fa fa-whatsapp"></i></a></li>
                    <li><a href="https://www.linkedin.com/company/irfanelectricals" className="icoLinkedin" title="LinkedIn"><i className="fa fa-linkedin"></i></a></li>
                  </ul>
                </div>
              </div>


              <div className="col-md-2">
                <div className="footer_1i">
                  <h4 className="col_yell mb-3">Useful Links</h4>
                  <div className="row footer_1i_sm">
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/terms-and-conditions">Terms & Conditions</a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/privacy-and-policy"> Privacy Policy </a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/shipping-and-delivery-policy">Shipping & Delivery</a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/cancellations-and-refund-policy">Cancellation & Refund</a></h6>
                  </div>
                </div>
              </div>

              <div className="col-md-2">
                <div className="footer_1i">
                  <h4 className="col_yell mb-3">Quick Links</h4>
                  <div className="row footer_1i_sm">
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/">Home</a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/about">About</a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/shop">Shop</a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="/blog">Blog</a></h6>
                    <h6 className="mb-3 col-md-12 col-6"><a className="text-light" href="certification">Certifications</a></h6>
                    <h6 className="mb-0 col-md-12 col-6"><a className="text-light" href="/contact">Contact</a></h6>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="footer_1i">
                  <h4 className="col_yell mb-3">Newsletter</h4>
                  <p className="text-light">Irfan Electricals provides quality electrical products and reliable services.</p>

                  <form onSubmit={handleSubscribe}>
                    <input
                      type="email"
                      className="form-control rounded-0 border-0"
                      placeholder="Enter Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <h6 className="mb-0 mt-4 text-uppercase">
                      <button type="submit" className="button_1" disabled={loading}>
                        {loading ? "Subscribing..." : "Submit"}
                      </button>
                    </h6>
                  </form>

                  {message && <p className="mt-2 text-light">{message}</p>}
                </div>

              </div>
            </div>

            <div className="row footer_3 text-center pt-3 mt-3">
              <div className="col-md-12">
                <p className="mb-0 text-light">© 2025 irfanelectricals.com . All Rights Reserved</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
